import PropTypes from 'prop-types';
import MatchAccaSelectionItemAvantgardeImpl from './match-acca-selection-item-avantgarde.js';
import MojitoCore from 'mojito/core';

const { UIView } = MojitoCore.Presentation;

/**
 * Match acca selection info for a leg of a prebuilt card in the avantgarde layout.
 *
 * @class MatchAccaSelectionItemAvantgarde
 * @memberof Mojito.Presentation.Modules
 */

/**
 * MatchAccaSelectionItemAvantgarde component prop types.
 *
 * @property {string} selectionLabel - Selection label to be shown.
 * @property {string} [marketName] - Market name to be shown.
 * @property {string} [eventName] - Event name to be shown.
 * @property {boolean} showSeparator - If true the row is followed by another one and the row divider is shown when the showRowDivider config flag is enabled.
 * @property {object} [earlyPayout] - Early Payout object.
 * @property {string|Date} [eventStartTime] - Start time of the event the selection belongs to. Only rendered when the showPartMetadata config flag is enabled.
 * @property {string} [price] - Formatted price of the selection. Only rendered when the showPartMetadata config flag is enabled.
 * @property {string} [basePrice] - Formatted price the selection was boosted from. Rendered struck through next to the price.
 * @property {boolean} [neutral] - If true the event is played at a neutral venue and the neutral venue indicator is shown. Only rendered when the showPartMetadata config flag is enabled.
 *
 * @memberof Mojito.Presentation.Modules.MatchAccaSelectionItemAvantgarde
 */
const propTypes = {
    selectionLabel: PropTypes.string.isRequired,
    marketName: PropTypes.string,
    eventName: PropTypes.string,
    showSeparator: PropTypes.bool.isRequired,
    earlyPayout: PropTypes.object,
    eventStartTime: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    price: PropTypes.string,
    basePrice: PropTypes.string,
    neutral: PropTypes.bool,
};

export default UIView(
    'MatchAccaSelectionItemAvantgarde',
    MatchAccaSelectionItemAvantgardeImpl,
    propTypes
);
